
import React, { Component } from "react";
import { connect } from "react-redux";
import { assessmentActions } from "../../../_actions";
import StudentHeader from "./Component/StudentHeader";
import NewStudentModal from "./Component/NewStudentModal";
import StudentEditModal from "./Component/StudentEditModal";
// import { IoIosArrowForward } from "react-icons/io";
import { LiaFileExcel } from "react-icons/lia";
import { MdOutlineEdit } from "react-icons/md";
import { RiDeleteBinLine } from "react-icons/ri";
import { TbReportAnalytics } from "react-icons/tb";
import { MdAutoMode, MdAddCircleOutline } from "react-icons/md";
import SelectAssessentCode from "./Modal/SelectAssessentCode";
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import moment from 'moment';
import { SheetJSFT } from "./types";
import NewUserModal from "./Modal/NewUserModal";
import UploadPreview from "./Modal/UploadPreview";

class StudentList extends Component {
  constructor(props) {
    super(props);
    this.handleDownloadExcel = this.handleDownloadExcel.bind(this);
    this.state = {
      showStudentModal: false,
      showStudentModal: false,
      updateStudentModal: false,
      schoolId: '',
      formStudentData: {
        "name": "",
        "std_class": "",
        "email": "",
        "mobile": "",
        "schoolId": this.props.match.params.id
      },
      updateFormStudentData: {
        "id": "",
        "name": "",
        "std_class": "",
        "email": "",
        "mobile": "",
        "schoolId": this.props.match.params.id
      },
      size: 10,
      crrSchoolId: this.props.match.params.id,
      crrStudentId: "",
      crrStudentData: {},


      showFilterNames: false,
      studentData: "",
      showEditDetails: false,

      tempEmpData: "",
      CrrEmpFilterLabel: "",
      showInputBox: false,
      newEmpFormData: {},

      loadedDataSheet: [],
      showUploadPreview: false,
      onboardingDateField: "",
      crrFieldType: [],

      showMobileSidebar: false,
      showNewStudentModal: false,
      file: []
    };
  }

  componentDidMount() {
    let paginationData1 = {
      "schoolId": this.state.crrSchoolId
    }
    this.props.dispatch(assessmentActions.getSchoolDetails(paginationData1));

    let paginationData = {
      "keyWord": "",
      "pageNo": 1,
      "size": this.state.size,
      "schoolId": this.state.crrSchoolId
    }
    this.props.dispatch(assessmentActions.getStudentList(paginationData));
    window.scrollTo(0, 0);
  }

  handleNewSchoolModal = (value) => {
    this.setState({ showStudentModal: value });
  };

  gotoPage2 = (field) => {
    const { history } = this.props;
    history.push(`/assessment/${field}`);
  };


  handleEditStudentModal = (value) => {
    let data = {
      "id": value.id,
      "name": value.name,
      "std_class": value.std_class,
      "email": value.email,
      "mobile": value.mobile
    }
    this.setState({ updateFormStudentData: data, updateStudentModal: value });
  };

  handleStudentInput = (event) => {
    console.log("event---------.",event.target)
    let { formStudentData } = this.state;
    formStudentData[event.target.name] = event.target.value;
    this.setState({ formStudentData });
  };

  saveNewStudent = () => {
    let { name, std_class, email, mobile } = this.state.formStudentData;
    let data = {
      "name": name,
      "std_class": std_class,
      "email": email,
      "mobile": mobile,
      "schoolId": this.state.crrSchoolId
    }

    let paginationData = {
      "keyWord": "",
      "pageNo": 1,
      "size": this.state.size,
      "schoolId": this.state.crrSchoolId
    }
    this.props.dispatch(assessmentActions.createStudent(data, paginationData));

    setTimeout(() => {
      this.setState({
        formStudentData: {
          "name": "",
          "std_class": "",
          "email": "",
          "mobile": "",
          "schoolId": this.state.crrSchoolId
        },
        showStudentModal: false
      })
    }, 500)
  }


  handleNewStudentModal = (value) => {
    this.setState({ showAddStudentModal: value });
  };

  handleUpdateStudentModal = (value) => {
    this.setState({ updateStudentModal: value });
  };


  handleUpdateStudentInput = (event) => {
    let { updateFormStudentData } = this.state;
    updateFormStudentData[event.target.name] = event.target.value;
    this.setState({ updateFormStudentData });
  };

  saveUpdateStudent = () => {
    let { id, name, std_class, email, mobile } = this.state.updateFormStudentData;
    let data = {
      "id": id,
      "name": name,
      "std_class": std_class,
      "email": email,
      "mobile": mobile
    }

    let paginationData = {
      "keyWord": "",
      "pageNo": 1,
      "size": this.state.size,
      "schoolId": this.state.crrSchoolId
    }
    this.props.dispatch(assessmentActions.updateStudent(data, paginationData));

    setTimeout(() => {
      this.setState({
        updateFormStudentData: {
          "id": "",
          "name": "",
          "std_class": "",
          "email": "",
          "mobile": "",
          "schoolId": this.state.crrSchoolId
        },
        updateStudentModal: false
      })
    }, 500)
  }


  handleAsignAssessmentCode = (check, item) => {

    if (check) {
      this.setState({ crrStudentId: item.id, crrStudentData: item, showAssessmentCodeModal: true }, () => {
        this.props.dispatch(assessmentActions.getAssessmentCodeByTimestamp({ codeUsed: true }))
      });
    } else {
      this.setState({ crrStudentId: "", crrStudentData: {}, showAssessmentCodeModal: false });
    }

  }

  handleAddCodeToStd = (value) => {
    let reqData = {
      "purchaserOrderId": value,
      "id": this.state.crrStudentId
    }
    let paginationData = {
      "keyWord": "",
      "pageNo": 1,
      "size": this.state.size,
      "schoolId": this.state.crrSchoolId
    }

    this.props.dispatch(assessmentActions.assignAssessmentCode(reqData, paginationData));
    setTimeout(() => {
      this.setState({ crrStudentId: "", crrStudentData: {}, showAssessmentCodeModal: false });
    }, 500)

  }

  handleSearchStudent = (event, data) => {

    console.log('datadatadatadatadatadatadatadatadatadatadatadatadatadatadata', data);
    event.preventDefault();
    let { value } = event.target;
    console.log('Value21313213213212313213212312132', value);
    const { schoolId } = this.state;
    if (!schoolId) {
      this.setState({
        error: 'Please select School first',
      });
    } else {
      this.setState({
        searchStudent: value, data, error: ''
      }, () => {
        let paginationData = {
          "keyWord": value,
          "pageNo": 1,
          "size": this.state.size,
          "schoolId": this.state.schoolId
        }
        this.props.dispatch(assessmentActions.getStudentList(paginationData));
      });
    }
  }

  handleDownloadExcel() {
    const { getStudentListData } = this.props.assessment;

    // Prepare data for Excel
    const data = getStudentListData.map((student, index) => ({
      SNo: index + 1,
      Name: student.name || "",
      Email: student.email || "",
      Mobile: student.mobile || "",
      Class: student.std_class || "",
      AssessmentCode: student.purchaserOrderId && student.purchaserOrderId.otpCode ? student.purchaserOrderId.otpCode : "Not Assigned",
      Status: student.status || "Not Assigned",
    }));

    // Create a worksheet from the data
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Students");

    // Write the file
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    saveAs(new Blob([wbout], { type: "application/octet-stream" }), "students.xlsx");
  }


  addStudentModal = (value) => {
    this.setState({ showStudentModal: value });
    this.setState({ fileUploadError: "" });
  };


  downLoadSampleCSV = () => {
    let binary_univers = [
      {
        student_id: "002",
        name: "Test Student",
        email: "teststudent@gmail.com",
        mobile: "000000000"
      },
    ];

    console.log("binary_univers: ", binary_univers);

    let binaryWS = XLSX.utils.json_to_sheet(binary_univers);

    // Create a new Workbook
    var wb = XLSX.utils.book_new();

    // Name your sheet
    XLSX.utils.book_append_sheet(wb, binaryWS, "Binary values");

    // export your excel
    XLSX.writeFile(wb, "sample student.xlsx");
  };



  handleChange = (e) => {

    const files = e.target.files;
    console.log("files; ", files)


    this.setState({ loadedDataSheet: [], showUploadPreview: true }, () => {

      if (files && files[0]) {
        let fileName = files && files[0] && files[0].name ? files[0].name : "";
        let extName1 =
          fileName && fileName.substr(fileName.length - 3)
            ? fileName.substr(fileName.length - 3)
            : "";
        let extName2 =
          fileName && fileName.substr(fileName.length - 4)
            ? fileName.substr(fileName.length - 4)
            : "";
        if (extName1 === "csv" || extName2 === "xlsx") {
          this.setState({ file: files[0] }, () => {
            console.log("this.state.file", this.state.file);
            this.setState({ fileUploadError: "" });

            //----------------------------------------------------------------------------------------------------------------------------------------------------------
            const reader = new FileReader();
            const rABS = !!reader.readAsBinaryString;

            if (this.state.file) {
              if (rABS) {
                reader.readAsBinaryString(this.state.file);
              } else {
                reader.readAsArrayBuffer(this.state.file);
              }
            }

            console.log(
              "rABS--------------------------------------------->",
              rABS
            );

            reader.onload = (e) => {
              /* Parse data */
              const bstr = e.target.result;
              const wb = XLSX.read(bstr, {
                type: rABS ? "binary" : "array",
                bookVBA: true,
              });
              /* Get first worksheet */
              const wsname = wb.SheetNames[0];
              const ws = wb.Sheets[wsname];
              console.log(
                "before ws--------------------------------------------->",
                ws
              );

              //-------------------------------------------------------------------------------------------------------------
              // var isDate = function (date) {
              //   return (new Date(date) !== "Invalid Date") && !isNaN(new Date(date));
              // }
              let listKeys = ws ? Object.keys(ws) : [];
              if (listKeys && listKeys.length > 0) {
                listKeys.forEach((element) => {
                  if (ws[element]["t"] === "n") {
                    let wData = ws[element]["w"];
                    const toDateFormat = wData.toString();

                    if (moment(toDateFormat, "MM/DD/YY", true).isValid()) {
                      let wNewDate = moment(wData, "MM/DD/YY").format(
                        "DD-MM-YYYY"
                      );
                      if (wNewDate) {
                        ws[element]["v"] = wNewDate;
                        ws[element]["w"] = wNewDate;
                        // console.log("wData--------->",ws[element])
                      }
                    } else if (
                      moment(toDateFormat, "MM/DD/YYYY", true).isValid()
                    ) {
                      let wNewDate = moment(wData, "MM/DD/YYYY").format(
                        "DD-MM-YYYY"
                      );
                      if (wNewDate) {
                        ws[element]["v"] = wNewDate;
                        ws[element]["w"] = wNewDate;
                        // console.log("wData--------->",ws[element])
                      }
                    } else if (
                      moment(toDateFormat, "M/DD/YY", true).isValid()
                    ) {
                      let wNewDate = moment(wData, "M/DD/YY").format(
                        "DD-MM-YYYY"
                      );
                      if (wNewDate) {
                        ws[element]["v"] = wNewDate;
                        ws[element]["w"] = wNewDate;
                        console.log("wData--------->", ws[element]);
                      }
                    } else if (
                      moment(toDateFormat, "MM/D/YY", true).isValid()
                    ) {
                      let wNewDate = moment(wData, "MM/D/YY").format(
                        "DD-MM-YYYY"
                      );
                      if (wNewDate) {
                        ws[element]["v"] = wNewDate;
                        ws[element]["w"] = wNewDate;
                        console.log("wData--------->", ws[element]);
                      }
                    } else if (moment(toDateFormat, "M/D/YY", true).isValid()) {
                      let wNewDate = moment(wData, "M/D/YY").format(
                        "DD-MM-YYYY"
                      );
                      if (wNewDate) {
                        ws[element]["v"] = wNewDate;
                        ws[element]["w"] = wNewDate;
                        console.log("wData--------->", ws[element]);
                      }
                    } else if (
                      moment(toDateFormat, "M/DD/YYYY", true).isValid()
                    ) {
                      let wNewDate = moment(wData, "M/DD/YYYY").format(
                        "DD-MM-YYYY"
                      );
                      if (wNewDate) {
                        ws[element]["v"] = wNewDate;
                        ws[element]["w"] = wNewDate;
                        console.log("wData--------->", ws[element]);
                      }
                    } else if (
                      moment(toDateFormat, "MM/D/YYYY", true).isValid()
                    ) {
                      let wNewDate = moment(wData, "MM/D/YYYY").format(
                        "DD-MM-YYYY"
                      );
                      if (wNewDate) {
                        ws[element]["v"] = wNewDate;
                        ws[element]["w"] = wNewDate;
                        console.log("wData--------->", ws[element]);
                      }
                    } else if (
                      moment(toDateFormat, "M/D/YYYY", true).isValid()
                    ) {
                      let wNewDate = moment(wData, "M/D/YYYY").format(
                        "DD-MM-YYYY"
                      );
                      if (wNewDate) {
                        ws[element]["v"] = wNewDate;
                        ws[element]["w"] = wNewDate;
                        console.log("wData--------->", ws[element]);
                      }
                    }

                    // const dateFormat = ['MM/DD/YY', 'MM/DD/YYYY'];
                    // if (moment(toDateFormat, dateFormat, true).isValid()) {
                    //   // console.log('toDateFormat ws--------------------------------------------->', toDateFormat)
                    //   // console.log('wData ws--------------------------------------------->', wData)
                    //   // console.log('moment ws--------------------------------------------->', moment(toDateFormat, dateFormat, true).isValid())

                    //   let wNewDate = moment(wData, "MM/DD/YYYY").format("DD-MM-YYYY");
                    //   if (wNewDate) {
                    //     ws[element]["v"] = wNewDate
                    //     ws[element]["w"] = wNewDate
                    //   }

                    //   // console.log('valid2 ws--------------------------------------------->', ws[element]["v"])
                    //   // console.log('valid2 element--------------------------------------------->', ws[element])

                    // }
                  }
                });
              }

              console.log(
                "after ws--------------------------------------------->",
                ws
              );
              //-------------------------------------------------------------------------------------------------------------

              /* Convert array of arrays */
              let data = XLSX.utils.sheet_to_json(ws);
              // ////console.log("datadatadatadata ", data);

              // moment("06/22/2015", "MM/DD/YYYY", true).isValid()

              data = data.map((v) => ({ ...v }));

              console.log(
                "data--------------------------------------------->",
                data
              );

              setTimeout(() => {
                this.setState({
                  loadedDataSheet: data,
                  showUploadPreview: true,
                  showStudentModal: false,
                });
              }, 1000);
            };

            //------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
          });
        } else {
          this.setState({ fileUploadError: "Please upload csv or xlsx file!" });
          ////console.log("not csv or xlsx file")
        }
      } else {
        this.setState({ fileUploadError: "Please upload csv or xlsx file!" });
      }
    });
  };


  closeUploadPreview = () => {
    this.setState({ showUploadPreview: false, loadedDataSheet: [] });
  };

  saveUploadStudent = () => {
    let { loadedDataSheet } = this.state;
    if (loadedDataSheet && loadedDataSheet.length > 0) {
      let paginationData = {
        "keyWord": "",
        "pageNo": 1,
        "size": this.state.size,
        "schoolId": this.state.crrSchoolId
      }
      this.props.dispatch(
        assessmentActions.uploadStudentList(loadedDataSheet.map((ele)=>({
          ...ele,
          "schoolId": this.state.crrSchoolId
        })), paginationData)
      );
    }

    // if(onboardingDateField){

    //   this.props.dispatch(surveyActions.saveEmpDateField({
    //     "onboardingField":onboardingDateField?onboardingDateField:null
    //   }));

    // }
  };



  render() {

    let { assessment } = this.props;
    let { getStudentListData, getSchoolDetailsData, getAssessmentCodeByTimestampData,
      uploadStudentListData
    } = assessment;
    let { showAddStudentModal, showNewStudentModal, showUploadPreview, showStudentModal, onboardingDateField,
      crrFieldType,
      showAssessmentCodeModal, crrStudentData, updateStudentModal, updateFormStudentData, formStudentData } = this.state;

    const checkFormat = (ele, field) => {
      return ele && ele[field] ? ele[field] : ""
    }

    const data = getStudentListData && getStudentListData.length > 0 ? getStudentListData.map((ele) => ({
      id: checkFormat(ele, "id"),
      name: checkFormat(ele, "name"),
      std_class: checkFormat(ele, "std_class"),
      email: checkFormat(ele, "email"),
      mobile: checkFormat(ele, "mobile"),
      date: checkFormat(ele, "createdAt")
        ? moment(checkFormat(ele, "createdAt"))
          .utcOffset("+05:30")
          .format("DD/MM/YYYY")
        : "",
      code: ele && ele.purchaserOrderId && ele.purchaserOrderId.otpCode ? ele.purchaserOrderId.otpCode : "",
      status: 'Not Assigned'
    })) : []


    let fieldList = [
      {
        "label": "Student Name",
        "value": "name",
        "type": "text"
      },
      {
        "label": "Student Class",
        "value": "std_class",
        "type": "text"
      },
      {
        "label": "Student Email",
        "value": "email",
        "type": "email"
      },
      {
        "label": "Student Ph No",
        "value": "mobile",
        "type": "mobile"
      }
    ]

    return (
      <>
        <StudentHeader />

        <div className="flex items-start justify-center pb-10 bg-[#FAFAFA] h-screen">
          <section className="px-4 xl:w-11/12 mx-auto w-full xl:px-0">

            <div className="flex flex-col items-center justify-between gap-4 p-4 md:flex-row">
              <h1 className="font-semibold md:text-xl text-lg line-clamp-1 text-[#3D405B]">{
                getSchoolDetailsData && getSchoolDetailsData.name ? getSchoolDetailsData.name : ""}<span className="text-[#212121] font-light"> | </span><span className="text-[#2196F3] text-sm font-medium cursor-pointer" onClick={() => this.gotoPage2("student-school")} > School  {">"} <span className="text-[#212121]/70 font-mediums">{
                  getSchoolDetailsData && getSchoolDetailsData.name ? getSchoolDetailsData.name : ""
                }</span></span> </h1>
            </div>

            <div className="bg-white border p-4">

              <div className="w-full flex-1 space-y-4 text-[#3D405B]">
                <div className="items-stretch justify-between space-y-4 lg:flex md:space-x-6 md:space-y-0">
                  <div className="flex space-x-3 items-center">
                    <div className="flex space-x-2 capitalize items-center text-sm text-[#212121]/70 font-medium">
                      <span>Show</span>
                      <form class="w-16">
                        <select id="entries" class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg block w-full px-2 py-1.5 focus:outline-none">
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </select>
                      </form>
                      <span>entries</span>
                    </div>
                  </div>

                  <div className="flex space-x-4">
                    <div className="w-full flex justify-between border px-4 text-[#212121]/70 bg-white rounded-md text-sm items-center  overflow-hidden">
                      <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-search" width="24" height="24" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"
                      > <path stroke="none" d="M0 0h24v24H0z" fill="none" /> <circle cx="10" cy="10" r="7" /> <line x1="21" y1="21" x2="15" y2="15" />
                      </svg>
                      <input type="search" name="search" onChange={this.handleSearchStudent} placeholder="Search by email..." className="w-44 focus:outline-none px-2 py-2 text-[#212121]/70 placeholder:text-[#212121]/70 placeholder:font-normal font-medium " />
                    </div>

                    <div onClick={this.handleDownloadExcel} className="flex items-center py-3 px-4 text-sm border whitespace-nowrap rounded-md cursor-pointer font-medium text-[#212121]/70 md:w-auto w-full" >
                      <span className="mr-2 " >
                        <LiaFileExcel className="w-5 h-5" />
                      </span> Download Excel
                    </div>

                    <button onClick={() => this.addStudentModal(true)} className="cursor-pointer bg-[#2196F3] text-white space-x-1 text-sm  border-[#2196F3] flex justify-between px-4 items-center py-2 rounded-md whitespace-nowrap">
                      <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-circle-plus" width="24" height="24" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round" >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" /><circle cx="12" cy="12" r="9" />  <line x1="9" y1="12" x2="15" y2="12" />  <line x1="12" y1="9" x2="12" y2="15" /></svg><span> Upload Excel</span>
                    </button>

                    <button onClick={() => this.handleNewStudentModal(true)} className="cursor-pointer bg-[#2196F3] text-white space-x-1 text-sm  border-[#2196F3] flex justify-between px-4 items-center py-2 rounded-md whitespace-nowrap">
                      <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-circle-plus" width="24" height="24" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round" >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" /><circle cx="12" cy="12" r="9" />  <line x1="9" y1="12" x2="15" y2="12" />  <line x1="12" y1="9" x2="12" y2="15" /></svg><span> Add Student</span>
                    </button>

                  </div>
                </div>

                {/* Table design secction */}
                <div className="w-full mx-auto">
                  <div className="inline-block min-w-full">
                    <table className="min-w-full border">
                      <thead className="bg-gray-50">
                        <tr>
                          <th className="px-3 w-16 py-3 text-center border text-sm font-semibold text-gray-900">S.No.</th>
                          <th className="px-3 py-3 text-left border text-sm font-semibold text-gray-900">Name</th>
                          <th className="px-3 py-3 text-center border text-sm font-semibold text-gray-900">Class</th>
                          <th className="px-3 py-3 text-left border text-sm font-semibold text-gray-900">Email Address</th>
                          <th className="px-3 py-3 text-center border text-sm font-semibold text-gray-900">Date Created</th>
                          <th className="px-3 py-3 text-center border text-sm font-semibold text-gray-900 w-72">
                            <div className="space-x-2 flex items-center justify-center">
                              <span>Assessment Code</span>
                              <span className="text-[#2196F3] flex items-center justify-center border border-[#2196F3] px-2 py-1 rounded-md"><MdAutoMode className="w-4 h-4 mr-1" />Auto Add</span>
                            </div>
                          </th>
                          <th className="px-3 py-3 text-center border text-sm font-semibold text-gray-900">Assessment Status</th>
                          {/* <th className="px-3 py-3 text-center border text-sm font-semibold text-gray-900">Status</th> */}
                          <th className="px-3 py-3 text-center border text-sm font-semibold text-gray-900">Actions</th>
                        </tr>
                      </thead>
                      <tbody className="border divide-gray-200 bg-white">
                        {data && data.length > 0 ? (
                          data.map((item, index) => (
                            <tr className="hover:bg-gray-100">
                              <td className="whitespace-nowrap px-2 py-2 border text-sm text-center">{index + 1}</td>
                              <td className="whitespace-nowrap px-2 py-2 border text-sm">{item.name}</td>
                              <td className="whitespace-nowrap px-2 py-2 border text-sm text-center">{item.std_class}</td>
                              <td className="whitespace-nowrap px-2 py-2 border text-sm">{item.email}</td>
                              <td className="whitespace-nowrap px-2 py-2 border text-sm text-center w-36">{item.date}</td>
                              <td className="whitespace-nowrap px-2 py-2 border text-sm">
                                {item && item.code ?
                                  <div className="flex items-center justify-center cursor-pointer">
                                    <div className="space-x-2 flex items-center justify-center">
                                      <p className="border-dashed border-2 px-3 py-1 w-32 rounded-md text-center border-[#4CAF50] bg-[#4CAF50]/20 text-[#4CAF50] font-medium">{item.code}</p>
                                    </div>
                                  </div>
                                  :
                                  <div className="flex items-center justify-center cursor-pointer">
                                    <span onClick={() => this.handleAsignAssessmentCode(true, item)} className="text-[#212121] flex items-center justify-center">
                                      <MdAddCircleOutline className="w-7 h-7 mr-1 border p-1 rounded-md text-[#212121]/70" />
                                      Add Code</span>
                                  </div>
                                }
                              </td>

                              <td className="whitespace-nowrap px-2 py-2 border text-sm w-44">
                                <div className="flex items-center justify-center">
                                  <div
                                    id="entries"
                                    className={`bg-gray-50 border cursor-pointer border-gray-300 text-center text-gray-900 text-sm rounded-md w-32 px-3 py-1.5 focus:outline-none ${item.status === 'Completed' ? 'bg-green-500 text-white' : item.status === 'Pending' ? 'bg-yellow-500 text-white' : 'bg-white text-gray-900'}`}
                                  >
                                    {item.status}
                                  </div>
                                </div>
                              </td>


                              {/* <td className="whitespace-nowrap px-2 py-2 border text-sm">
                                <select
                                  id="entries"
                                  className={`bg-gray-50 border cursor-pointer border-gray-300 text-gray-900 text-sm rounded-md block w-full px-1 py-1.5 focus:outline-none ${item.status === 'Active' ? 'bg-green-500 text-white' : 'bg-white text-gray-900'}`}
                                >
                                  <option className="option" value="Inactive" selected={item.status === 'Inactive'}>Inactive</option>
                                  <option className="option" value="Active" selected={item.status === 'Active'}>Active</option>
                                </select>
                              </td> */}

                              <td className="whitespace-nowrap px-2 py-2 border text-sm">
                                <div className="flex justify-center items-center space-x-2" >
                                  <button className="text-base border rounded-md p-1 cursor-pointer text-[#212121]/70 hover:bg-[#2196F3] hover:text-white">
                                    <RiDeleteBinLine size={18} />
                                  </button>
                                  <button onClick={() => this.handleEditStudentModal(item)} className="text-base border rounded-md p-1 cursor-pointer text-[#212121]/70 hover:bg-[#2196F3] hover:text-white">
                                    <MdOutlineEdit size={18} />
                                  </button>
                                  <button className="text-base border rounded-md p-1 cursor-pointer text-[#212121]/70 hover:bg-[#2196F3] hover:text-white">
                                    <TbReportAnalytics size={18} />
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="9" className="px-4 py-8 text-center">
                              <div className="flex flex-col items-center space-y-4 justify-center md:py-8 py-6">
                                <img src="/assessment_images/no-users.svg" alt="no-users" className="w-36 2xl:w-40" />
                                <h2 className="capitalize md:text-3xl text-2xl font-semibold text-[#3D405B] pt-4">Data not found!</h2>
                                <p className="text-gray-500 text-lg">Looks like you haven’t added any user yet.</p>
                              </div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>

              </div>

            </div>
            {/* Data not Found section */}
            {/* <section className="flex items-center justify-center w-full col-span-2 gap-10 px-4 mx-auto overflow-hidden">
                <div className="flex flex-col items-center space-y-4 justify-center md:py-10 py-8 text-center">
                  <img src="/assessment_images/no-users.svg" alt="no-users.svg" className="w-3/6 2xl:w-2/4" />
                  <h2 className="capitalize md:text-3xl text-2xl font-semibold text-[#3D405B] pt-4">Data not found!</h2>
                  <p className="text-gray-500 text-lg">Looks like you haven’t added any user yet.</p>
                  <div onClick={() => this.handleNewSchoolModal(true)} className="mt-0 md:mt-4 bg-[#2196F3] border border-[#2196F3] text-white py-2 px-5 rounded uppercase flex items-center justify-center space-x-3">
                    <span><svg width="30" height="30" viewBox="0 0 81 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M30.3281 40H50.3281M40.3281 30V50M10.3281 40C10.3281 43.9397 11.1041 47.8407 12.6117 51.4805C14.1194 55.1203 16.3292 58.4274 19.1149 61.2132C21.9007 63.999 25.2079 66.2087 28.8476 67.7164C32.4874 69.224 36.3885 70 40.3281 70C44.2678 70 48.1689 69.224 51.8086 67.7164C55.4484 66.2087 58.7556 63.999 61.5413 61.2132C64.3271 58.4274 66.5369 55.1203 68.0445 51.4805C69.5522 47.8407 70.3281 43.9397 70.3281 40C70.3281 36.0603 69.5522 32.1593 68.0445 28.5195C66.5369 24.8797 64.3271 21.5726 61.5413 18.7868C58.7556 16.001 55.4484 13.7913 51.8086 12.2836C48.1689 10.776 44.2678 10 40.3281 10C36.3885 10 32.4874 10.776 28.8476 12.2836C25.2079 13.7913 21.9007 16.001 19.1149 18.7868C16.3292 21.5726 14.1194 24.8797 12.6117 28.5195C11.1041 32.1593 10.3281 36.0603 10.3281 40Z" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                    </svg></span>
                    <button className="">Add New School</button>
                  </div>
                </div>
              </section> */}

          </section>
        </div>

        {showAddStudentModal ? (
          <>
            <NewStudentModal
              handleNewStudentModal={this.handleNewStudentModal}
              handleStudentInput={this.handleStudentInput}
              formStudentData={formStudentData}
              saveNewStudent={this.saveNewStudent}
              fieldList={fieldList}
            />
          </>
        ) : null}

        {updateStudentModal ? (
          <>
            <StudentEditModal
              handleUpdateStudentModal={this.handleUpdateStudentModal}
              handleUpdateStudentInput={this.handleUpdateStudentInput}
              updateFormStudentData={updateFormStudentData}
              saveUpdateStudent={this.saveUpdateStudent}
              fieldList={fieldList}
            />
          </>
        ) : null}


        {showAssessmentCodeModal ? (
          <>
            <SelectAssessentCode
              closeModal={this.handleAsignAssessmentCode}
              list={getAssessmentCodeByTimestampData}
              crrStudentData={crrStudentData}
              handleAddCodeToStd={this.handleAddCodeToStd}
            />
          </>
        )

          : null}



        {showNewStudentModal ? (
          <>
            <NewUserModal
              newEmpFormData={this.state.newEmpFormData}
              handleNewEmpInput={this.handleNewEmpInput}
              saveNewStudent={this.saveNewStudent}
              addNewStudent={this.addStudentModal}
              addNewEmpOtherField={this.addNewEmpOtherField}
              handleNewEmpOtherInput={this.handleNewEmpOtherInput}
            />
          </>
        ) : null}

        {showUploadPreview ? (
          <>
            <UploadPreview
              loadedDataSheet={this.state.loadedDataSheet}
              closeUploadPreview={this.closeUploadPreview}
              saveUploadStudent={this.saveUploadStudent}
              handleChange={this.handleChange}
              SheetJSFT={SheetJSFT}
              saveStudentListData={uploadStudentListData}
              selectOnboardingDateField={this.selectOnboardingDateField}
              onboardingDateField={onboardingDateField}
              selectFieldType={this.selectFieldType}
              crrFieldType={crrFieldType}
              getStudentFieldsData={[]}
            />
          </>
        ) : null}





        {showStudentModal ? (
          <div className="fixed top-0 right-0 z-40 flex items-center justify-center w-full h-full bg-black bg-opacity-40 xl:h-screen">
            <div className="w-11/12 mx-auto bg-white rounded-lg shadow-sm xl:w-6/12 lg:w-9/12 ">
              {/* head */}
              <div className="flex items-center justify-between p-4 border-b md:px-8 ">
                <h2 className="text-lg font-semibold md:text-xl test-gray-800 ">
                  Add Students
                </h2>

                <div
                  onClick={() => this.addStudentModal(false)}
                  className="p-2 rounded-full cursor-pointer bg-slate-100 hover:bg-slate-200 "
                >
                  <svg
                    className="w-6 h-6 fill-current"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                  >
                    <path d="M16.192 6.344L11.949 10.586 7.707 6.344 6.293 7.758 10.535 12 6.293 16.242 7.707 17.656 11.949 13.414 16.192 17.656 17.606 16.242 13.364 12 17.606 7.758z"></path>
                  </svg>
                </div>
              </div>

              <div className="m-4 space-y-8 md:m-8 ">
                {/* data here */}
                <div className="p-4 space-y-2 text-sm border divide-y rounded-md text-slate-800">
                  <h1 className="text-lg font-semibold text-slate-800 ">
                    {" "}
                    Guidelines for uploading the data
                  </h1>
                  <ol className="list-disc pl-6 space-y-1.5 py-4 text-slate-800 ">
                    <li className="">
                      {" "}
                      Mandatory Column include emp_id and email as first
                      column & second column should be in the file.
                    </li>
                    <li className="capitalize">
                      {" "}
                      Your file columns/headers should not contain any
                      special characters – this includes characters that
                      are not numbers or the English alphabet.
                    </li>
                    <li className="capitalize">
                      {" "}
                      Be careful not to include duplicates of the same
                      row – no two students should have the same emp_id
                      or email.
                    </li>
                    <li className="capitalize">
                      {" "}
                      Date format must be same as DD-MM-YYYY
                    </li>
                    <li className="capitalize">
                      {" "}
                      See the sample data format for reference and
                      prepare your master data accordingly without any
                      change in mandatory column names
                    </li>
                    <li className="capitalize">
                      {" "}
                      Make sure your Excel sheet is not password
                      protected.
                    </li>


                  </ol>
                </div>


                <div className="space-y-4">
                  <div className="grid grid-cols-1 gap-4 xl:grid-cols-4 md:grid-cols-2">
                    {/* 1 */}
                    <div
                      onClick={() => this.downLoadSampleCSV()}
                      className="flex items-start p-2 px-4 space-x-4 rounded shadow-sm cursor-pointer 2xl:items-center bg-sky-100 md:col-span-2"
                    >
                      <span class="material-symbols-outlined p-2 bg-white rounded-full text-blue-500 shadow-sm">
                        download
                      </span>
                      <div>
                        <h1 className="text-sm font-medium md:text-base text-slate-800 ">
                          Download Sample Data
                        </h1>
                        <p className="text-sm text-gray-500">
                          See the sample data format for reference
                        </p>
                      </div>
                    </div>

                    <input
                      type="file"
                      id="file"
                      accept={SheetJSFT}
                      onChange={this.handleChange}
                      hidden
                    />
                    <label
                      for="file"
                      className="rounded shadow-sm cursor-pointer bg-sky-100 md:col-span-2"
                    >
                      <div className="flex items-start p-2 px-4 space-x-4 2xl:items-center ">
                        <span class="material-symbols-outlined p-2 bg-white rounded-full text-blue-500 shadow-sm">
                          upload
                        </span>
                        <div>
                          <h1 className="text-sm font-medium md:text-base text-slate-800 ">
                            Upload Master Data
                          </h1>
                          <p className="text-sm text-gray-500">
                            Upload master data as per the guidelines
                          </p>
                        </div>
                      </div>
                    </label>
                  </div>

                  <div className="hidden">
                    <button
                      onClick={() => this.downLoadSampleCSV()}
                      className=" border border-green-500 rounded-md px-6 py-1.5 text-xs text-green-500 focus:outline-none"
                    >
                      Sample CSV
                    </button>

                    <button
                      onClick={this.handleFile}
                      className="ml-22 border border-blue-500 rounded-md px-6 py-1.5 text-xs text-blue-500 focus:outline-none"
                    >
                      Continue
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : null}





      </>
    );
  }
}

StudentList.defaultProps = {
  center: { lat: 26.953021, lng: 75.739797 },
  zoom: 15,
};
function mapStateToProps(state) {
  //console.log("state  ", state);
  const { loggingIn } = state.authentication;
  const { questions, user, assessment } = state;
  return {
    loggingIn,
    questions,
    user,
    assessment,
  };
}

export default connect(mapStateToProps)(StudentList);
